import styled, { CSSProp } from 'styled-components'

export const DropDownCountryNameUi = styled.span<{
  styles?: CSSProp
}>`
  margin-right: 0.5em;

  ${({ styles }) => styles}
`
